import { Link } from 'react-router-dom';

export function LandingPage() {
  return (
    <div className="flex min-h-dvh flex-col">
      {/* Hero */}
      <section className="flex flex-col items-center px-6 py-16 text-center sm:py-24">
        <h1 className="mb-4 text-4xl font-bold text-gray-900 sm:text-5xl">
          Bransoletki Designer
        </h1>
        <p className="mb-8 max-w-md text-lg text-gray-600">
          Projektuj wzory koralikowe online. Loom, Peyote, Brick Stitch — rysuj, importuj zdjęcia,
          eksportuj PDF.
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link
            to="/login"
            className="rounded-xl bg-primary-600 px-8 py-3 text-lg font-semibold text-white shadow-lg hover:bg-primary-700"
          >
            Zaloguj się
          </Link>
          <Link
            to="/login?mode=register"
            className="rounded-xl border-2 border-gray-300 px-8 py-3 text-lg font-semibold text-gray-700 hover:bg-gray-50"
          >
            Utwórz konto
          </Link>
        </div>
      </section>

      {/* Features */}
      <section className="bg-gray-50 px-6 py-16">
        <div className="mx-auto max-w-4xl">
          <h2 className="mb-10 text-center text-2xl font-bold text-gray-900">Funkcje</h2>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {FEATURES.map((f) => (
              <div key={f.title} className="rounded-xl bg-white p-5 shadow-sm">
                <div className="mb-3 text-3xl">{f.icon}</div>
                <h3 className="mb-1 font-semibold text-gray-900">{f.title}</h3>
                <p className="text-sm text-gray-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="flex flex-col items-center px-6 py-16 text-center">
        <h2 className="mb-4 text-2xl font-bold text-gray-900">Gotowy do tworzenia?</h2>
        <p className="mb-6 text-gray-600">Darmowe, działa w przeglądarce, bez instalacji.</p>
        <Link
          to="/editor/new"
          className="rounded-xl bg-primary-600 px-8 py-3 text-lg font-semibold text-white shadow-lg hover:bg-primary-700"
        >
          Otwórz edytor
        </Link>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-200 px-6 py-6 text-center text-xs text-gray-400">
        Bransoletki Designer &copy; {new Date().getFullYear()}
      </footer>
    </div>
  );
}

const FEATURES = [
  {
    icon: '🎨',
    title: '3 techniki',
    desc: 'Loom, Peyote Stitch i Brick Stitch z dokładnym renderowaniem siatki.',
  },
  {
    icon: '📷',
    title: 'Import zdjęć',
    desc: 'Wgraj zdjęcie — algorytm CIEDE2000 dopasuje koraliki automatycznie.',
  },
  {
    icon: '📦',
    title: '370+ koralików',
    desc: 'Baza Miyuki Delica, Toho i Preciosa z kodami i kolorami.',
  },
  {
    icon: '📄',
    title: 'Eksport PDF',
    desc: 'Pobierz wzór z legendą kolorów i listą koralików.',
  },
  {
    icon: '📱',
    title: 'PWA / Mobile',
    desc: 'Działa na telefonie, tablecie i desktopie. Zainstaluj z przeglądarki.',
  },
  {
    icon: '🔒',
    title: 'Twoje projekty',
    desc: 'Zapisuj wzory na koncie, autosave co 5 sekund.',
  },
] as const;
